import {
  times,
  debounce,
  get,
  set,
  keyBy,
  clone,
  cloneDeep,
  merge,
  mergeWith,
  isEqual,
} from 'lodash'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

const toRelativeTimeString = (timestamp: string | number) => {
  dayjs.extend(relativeTime)
  return dayjs().to(dayjs(Number(timestamp)))
}
const toAbsoluteTimeString = (timestamp: string | number) => {
  return dayjs(Number(timestamp)).format('DD MMMM YYYY')
}
export default {
  times,
  debounce,
  get,
  set,
  keyBy,
  clone,
  cloneDeep,
  merge,
  mergeWith,
  isEqual,
  toRelativeTimeString,
  toAbsoluteTimeString,
}
